import React from "react";
import styled from "styled-components";
import { Button, FlexContainer, Text, portalColors } from "src/components";
import AccountLinkingIcons from "src/img/noticeboard/social media.svg";

const TextDescription = styled.div`
    text-align: left;
    font-size: 14px;
    font-family: Manrope, Helvetica, sans-serif;
    font-weight: medium;
    color: ${portalColors.mutedText};
`;

const Card = styled.div`
    width: 100%;
    max-width: 544px;
    min-width: 32rem;
    padding: 16px;
    background: ${portalColors.surface};
    border: 1px solid ${portalColors.border};
    border-radius: 12px;
    box-sizing: border-box;

    @media (max-width: 768px) {
        min-width: unset;
        max-width: 100%;
        width: 100%;
    }
`;

const UpperButtons = styled(Button)`
    border-radius: 10px !important;
    border: ${p => p.border || "none"};
    height: 2.4375rem;
    width: 160px;
    color: ${p => p.color || "#fff"};
    background-color: ${p => p.backgroundColor || portalColors.text};
    box-sizing: border-box;
    font-size: 0.875rem;
    font-weight: 500;
    padding: ${p => p.padding};
    display: flex;
    align-items: center;
`;

const RowWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 1rem;
`;

const IconWrapper = styled.div`
    display: flex;
    align-items: center;
    flex-shrink: 0;
`;

const TextGroup = styled.div`
    flex: 1;
`;

const ButtonWrapper = styled.div`
    display: flex;
    margin-top: 1rem;

    @media (min-width: 769px) {
        margin-top: 0;
        margin-left: auto;
        align-items: flex-end;
    }

`;

const NoticeboardAccountLinkingCard = (props) => {
    const { toggleShowAccountLinkingPage } = props;
    return (
        <Card>
            <FlexContainer direction="row" tDirection="column" mDirection="row">
                <RowWrapper>
                    <IconWrapper>
                        <img src={AccountLinkingIcons} alt="Account Linking Banner" />
                    </IconWrapper>
                    <TextGroup>
                        <Text
                            weight="700"
                            size="20px"
                            align="left"
                            color={portalColors.text}
                            style={{ margin: "0 0 10px 0" }}
                        >
                            Social Account Linking
                        </Text>
                        <TextDescription>
                            Link your social accounts to post on Me Business and social platforms at once.
                        </TextDescription>
                    </TextGroup>
                </RowWrapper>

                <ButtonWrapper>
                    <UpperButtons backgroundColor="var(--calendar-action-primary-bg, #5B6EF5)" onClick={() => toggleShowAccountLinkingPage()}>
                        Linked Accounts
                    </UpperButtons>
                </ButtonWrapper>
            </FlexContainer>
        </Card>
    );
};
export default NoticeboardAccountLinkingCard;
